<template>
  <div class="loading-spinner" :class="`-size-${size}`">
    <div class="loading-spinner__spinner"></div>
  </div>
</template>

<script setup lang="ts">
const { size = 'medium' } = defineProps<{
  size?: "small" | "medium" | "large";
}>();
</script>

<style>
.loading-spinner {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 1em;
  height: 1em;
}
.loading-spinner.-size-small {
  font-size: 1rem;
}
.loading-spinner.-size-medium {
  font-size: 2rem;
}
.loading-spinner.-size-large {
  font-size: 3rem;
}

.loading-spinner__spinner {
  border: 4px solid rgba(var(--tint-contrast), 0.1);
  border-left-color: var(--color-primary);
  border-radius: 50%;
  width: 1em;
  height: 1em;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>